<template>
  <div class="mt-4  px-5">
    <h2>Text Editor</h2>
    <editor output-format="html" v-model="TextMail" :init="editorInit" />

    <v-dialog v-model="dialogSend" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Willst du wirklich senden?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialoge">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="sendMail">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      class="mt-5"
      @click="sendMail_Confirm"
      color="primary"><i class="far fa-save"></i> senden</v-btn>
  </div>
</template>

<script>
import { Editor, editorInit } from '@/plugins/tinymce';
export default {
  name: 'MassMail',
  components: {
    'editor': Editor
  },
  data: () => ({
    dialogSend: false,
    // print, paste und help gibt es in TinyMCE 6 nicht mehr
    editorInit: editorInit({
      height: 500,
      menubar: true,
      plugins: 'advlist autolink lists link image charmap preview anchor ' +
        'searchreplace visualblocks code fullscreen insertdatetime media table wordcount',
      toolbar: 'undo redo | blocks | bold italic backcolor | ' +
        'alignleft aligncenter alignright alignjustify | ' +
        'bullist numlist outdent indent | removeformat'
    }),
    TextMail: 'Hier kann der Mail-Text stehen ...',
  }),
  computed: {
  },
  methods: {
    sendMail_Confirm() {
      this.dialogSend = true
    },
    closeDialoge() {
      this.dialogSend = false
    },
    sendMail() {
      var Data;
      Data = {
        TextData: this.TextMail
      };
      this.dialogSend = false
      this.$store.dispatch('AdminApp/setSendMail', Data)
    },

  },
}
</script>

<style scoped>

</style>